import { getPermissionLevelIcon } from '../getPermissionLevelIcon';
import { onOpenSharingDialogClicked } from '../onOpenSharingDialogClicked';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { getAttachmentPermissionLevelString, ONE_DRIVE_PRO } from 'owa-attachment-permission';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getSharingLink, SharingLinkInfo } from 'owa-link-data';
import * as React from 'react';

const styles = require('../../components/LinkContextMenuCustomItems.scss');
const classNames = require('classnames');

export function getChangePermissionSharingDialogContextMenuItem(
    linkId: string
): IContextualMenuItem | null {
    if (!isFeatureEnabled('doc-attachment-sharingDialog')) {
        return null;
    }

    const sharingLink: SharingLinkInfo = getSharingLink(linkId);
    return {
        key: 'ChangePermissionsSharingDialog',
        onRender: (
            item: any,
            dismissMenu: (ev?: any, dismissAll?: boolean) => void
        ): React.ReactNode => {
            return (
                <button
                    className={classNames(styles.menuItemContainer, styles.buttonStyles)}
                    aria-label={getAttachmentPermissionLevelString(
                        sharingLink.permissionLevel,
                        ONE_DRIVE_PRO
                    )}
                    aria-posinset={1}
                    aria-setsize={7}
                    aria-disabled="false"
                    role="menuitem"
                    onClick={() => {
                        logUsage('AttachmentLinkViewChangePermissionSharingDialog');
                        onOpenSharingDialogClicked(sharingLink);
                    }}
                    tabIndex={0}>
                    <div className={styles.iconContainer}>
                        <img
                            src={getPermissionLevelIcon(sharingLink.permissionLevel)}
                            className={styles.permissionIcon}
                        />
                    </div>
                    <div className={classNames(styles.text, styles.paddingForChevron)}>
                        {getAttachmentPermissionLevelString(
                            sharingLink.permissionLevel,
                            ONE_DRIVE_PRO
                        )}
                    </div>
                    <Icon
                        iconName={ControlIcons.ChevronRight}
                        className={classNames(styles.chevronRight, 'flipForRtl')}
                    />
                </button>
            );
        },
    };
}
